import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { getCatalog } from '~/entities/catalog/api';
import { withGlobalSearch } from '~/entities/catalog/url-search';
import { ProductsPage } from '~/pages/products';

const searchSchema = withGlobalSearch({
  q: z.string().optional(),
  category: z.string().optional(),
  connection: z.string().optional(),
  location: z.string().optional(),
  color: z.string().optional(),
  panel: z.string().optional(),
  system: z.string().optional(),
  availability: z.string().optional(),
  attrs: z.string().optional(),
});

export const Route = createFileRoute('/products')({
  validateSearch: searchSchema,
  loader: async () => getCatalog(),
  component: ProductsRoute,
});

function ProductsRoute() {
  const { q, category, connection, location, color, panel, system, availability, attrs } = Route.useSearch();

  return (
    <ProductsPage
      q={q}
      category={category}
      connection={connection}
      location={location}
      color={color}
      panel={panel}
      system={system}
      availability={availability}
      attrs={attrs}
    />
  );
}
